import {Stack, TableCell, Typography} from '@mui/material'
import {useI18n} from 'store/Store'

const StatusCell = ({iconsMap, statusKey}) => {
    const {i18n} = useI18n()

    return (
        <TableCell>
            <Stack direction="row" gap={1}>
                {iconsMap[statusKey]}
                <Typography variant="body2">
                    {i18n.t(`dances.youtubeStatuses.${statusKey}`)}
                </Typography>
            </Stack>
        </TableCell>
    )
}

export default StatusCell
